<template>
<v-card v-if="trainer"  class="ma-0 app-screen-bg trainer-detail-page">
    <v-card-text class="trainer-detail-page__scroll pl-2 pl-md-10">
            <v-row class="ma-0 pa-0" dense>
              <v-col cols="12">
                  <v-card class="ma-0 pb-0">
                      <TrainerBag
                          :trainer="trainer"
                          :stones="stones"
                          :effect-items="effectItems"
                          :temp-pokemons="tempPokemons"
                          :pokeballs="pokeballs"
                          :reload-page="reloadPokemon"
                          :updater="counterReloader"
                          :eevee-stones="getEeveeStones()"
                          :in-fight="isFightMode"
                          :delete-pokemon-callback="deletePokemonCallback"
                      />
                  </v-card>
              </v-col>
            </v-row>
    </v-card-text>
</v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {WildType} from '@/utils/positionEnum';
    import TrainerBag from "@/components/trainer/TrainerBag";
    import {Categories} from "@/utils/itemsEnum";
    import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: {TrainerBag},
        data() {
            return {
                pokemonPool: 6,
                showDetail: false,
                pokemonDetail: null,
                categories: [],
                page: 1,
                loading: false,
                stones: [],
                effectItems: [],
                tempPokemons: [],
                wildType: WildType,
                updatePokemons: [],
                pokeballs: 0,
                counterReloader: 0,
                // vlastni lokalni kopie, ne sdileny trainer/item getter - ten prepisuji i jine komponenty pro CIZI trenery (souper, NPC)
                trainer: null,
            }
        },
        computed: {
            ...mapGetters({
                days: 'journey/days',
                user: 'user/item',
                pokemons: 'pokemon/items',
                isFightMode: 'journey/isFightMode',
            }),
        },
        watch: {
            page () {
                this.reloadList();
            },
            user () {
                this.loadData();
            },
            days() {
              this.loadData();
            },
            trainer() {
              this.getStones();
              this.getEffectItems();
            },
        },
        created() {
            this.categories = Categories;
            this.loadData(true);
            // journey/position se jinak nataci jen v Journey.vue - kdyz sem trener
            // prijde primo (bez predchozi navstevy /journey v teto relaci), isFightMode
            // by jinak zustal falesne false a item gate by se dal obejit.
            if (this.user && this.user.position && this.user.position.id !== undefined) {
                this.loadPosition(this.user.position.id);
            }
        },
        methods: {
            ...mapActions({
                fetchTrainerObject: 'trainer/fetchObject',
                updatePokemon: 'pokemon/updateItem',
                refreshActiveTeam: 'pokemon/refreshActiveTeam',
                loadPosition: 'journey/loadPosition',
            }),
            loadData(){
                if (this.user && this.user.id){
                    const url = new URL('api/trainers/' + this.user.id, API_ENTRYPOINT);
                    this.fetchTrainerObject({url: url, method: 'GET'}).then(
                        (data) => {
                            if (data) {
                                this.trainer = data;
                                this.pokeballs = this.trainer.pokeballs;
                                this.getStones();
                                this.getEffectItems();
                            }
                        }
                    );
                    this.reloadList();
                }

            },
            getEeveeStones() {
                if (this.trainer && this.trainer.items) {
                    let items =this.trainer.items;
                    if(typeof items === 'object' && items !== null) {
                        // items = this.trainer.items.values();
                        items = Object.keys(this.trainer.items).map((key) => {
                            return this.trainer.items[key];
                        })
                    }
                    return  items.filter(item =>
                        item.category === this.categories.CATEGORY_STONE
                        // && (item.type.id === 'FIRE' || item.type.id === 'ELECTRIC' || item.type.id === 'WATER')
                    );
                } else {
                    return [];
                }
            },
            reloadList(){
                this.tempPokemons = [];
                this.loading = true;
                this.refreshActiveTeam().then(
                    () => {
                        this.tempPokemons = this.pokemons.map(pokemon => pokemon.id);
                        this.loading = true;
                    }
                );
            },
            showDetailPokemon(id) {
                this.pokemonDetail = this.pokemons.find(pokemon =>pokemon.id === id);
                if ( this.pokemonDetail){
                    this.showDetail = true;
                }
            },
            deletePokemonCallback(id){
                this.tempPokemons =  this.tempPokemons.filter(e => e !== id);
                this.pokeballs += 1;
                // opusteny pokemon mohl byt v aktivnim tymu - TeamBottomSheet.vue o tom jinak nemela jak vedet
                this.refreshActiveTeam();
            },
            reloadPokemon() {
                this.counterReloader++;
                // counterReloader obnovi jen HP karty primo tady v Trainer Bagu (PokemonManager
                // watch(updater)) - teamboard/PokemonDetail v journey cte HP z pokemon/items
                // store, ktery timhle netekne (stejny duvod jako deletePokemonCallback vyse).
                this.refreshActiveTeam();
            },
            getStones() {
                if (this.trainer && this.trainer.items) {
                    let items = this.trainer.items;
                    if(typeof items === 'object' && items !== null) {
                        // items = this.trainer.items.values();
                        items = Object.keys(this.trainer.items).map((key) => {
                            return this.trainer.items[key];
                        })
                    }
                    this.stones = items.filter(item => item.category === 'EVOLUTION STONE');
                } else {
                    this.stones = [];
                }
            },
            // vse mimo evolucni kameny - permanentni (vlak/kolo/baterka) i spotrebni (Vselek/Super Vselek) itemy, viz Items.vue
            getEffectItems() {
                if (this.trainer && this.trainer.items) {
                    let items = this.trainer.items;
                    if (typeof items === 'object' && items !== null) {
                        items = Object.keys(this.trainer.items).map((key) => {
                            return this.trainer.items[key];
                        })
                    }
                    this.effectItems = items.filter(item => item.category !== 'EVOLUTION STONE');
                } else {
                    this.effectItems = [];
                }
            },

        },
    }
</script>

<style scoped>
    .trainer-detail-page {
        /* ne 100vh - viz komentar u ".new-shell-ui .v-main" v App.vue,
           odtud uz "height:100%" spravne zdedi vysku bez TopBaru */
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .trainer-detail-page__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 8px;
    }
</style>
